import type { JsonSchema } from '@restore/reform';
import { baseApiUrl } from 'src/config';
import { getAccessToken } from 'src/routes/AuthContext';

export const submitReformSupervisor = async (
  realm: string,
  formId: string,
  uuid: string,
  formData: JsonSchema,
  facilityId: string,
  note?: string
): Promise<{ success: boolean; error?: string; errorCode?: string; errorData?: any }> => {
  const token = await getAccessToken();
  const noteParam = note ? `&note=${encodeURIComponent(note)}` : '';
  const apiUrl = `${baseApiUrl}/document/form/supervisor/${formId}?webhookUuid=${uuid}${noteParam}`;

  return fetch(apiUrl, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'x-tenant-id': realm,
      Facility_id: facilityId,
      // THIN-7280: cosigner-edit goes through this fetch — without the IP header the
      // COSIGNER_EDIT audit row's signatureMetadata.signerIpAddress lands null. Mirrors
      // the pattern in signPhysicianDocument / undoDocSignatureFlow / applyTherapistBulkSign
      // (THIN-7279). document-service captures this and forwards it to provider-service
      // on the saveSubmissionData / finalizeSoapNote Feign calls.
      'X-Forwarded-For': localStorage.getItem('ip-address') ?? '',
    },
    body: JSON.stringify(formData),
  })
    .then(async (response) => {
      if (response.status === 200) {
        return { success: true };
      }

      let errorMessage = 'Something went wrong';
      try {
        const errorResponse = await response.json();
        if (errorResponse.message) {
          errorMessage = errorResponse.message;
        } else if (errorResponse.error) {
          errorMessage = errorResponse.error;
        }
      } catch (e) {
        errorMessage = response.statusText || `Request failed with status ${response.status}`;
      }

      return { success: false, error: errorMessage };
    })
    .catch((error) => {
      return { success: false, error: `Error submitting form: ${error.message || error}` };
    });
};
